import {
  LatestHistoryLeaverData,
  ReinstatementParams,
  ReinstatementResponse,
  SubmitIssueP45BySubcontractorIdParams,
  SubmitIssueP45BySubcontractorIdResponse,
  SubmitIssueP45Params,
  SubmitIssueP45Response,
  ValidateIssueP45BySubcontractorIdResponse,
  ValidateIssueP45Params,
  ValidateIssueP45Response,
} from '@nxsys/types/api/subcontractor';
import { ILeaverHistory } from '@nxsys/types/models/employment';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const validateIssueP45Api = async (
  params: ValidateIssueP45Params,
): Promise<ValidateIssueP45Response> => {
  const response = await axios.post(
    endPoints.report.dormant.validateP45,
    params,
  );
  return response.data;
};

export const submitIssueP45Api = async (
  params: SubmitIssueP45Params,
): Promise<SubmitIssueP45Response> => {
  const response = await axios.post(endPoints.report.dormant.p45, params);
  return response.data;
};

export const downloadLatestHistoryLeaverApi = async (
  id: string,
  type: string = 'download',
): Promise<{ data: string }> => {
  const response = await axios.get(
    endPoints.employee.downloadLatestHistoryLeaver(id),
    { params: { type } },
  );
  return response.data;
};

export const getLatestHistoryLeaverApi = async (
  id: string,
): Promise<{ data: LatestHistoryLeaverData }> => {
  const response = await axios.get(
    endPoints.employee.downloadLatestHistoryLeaver(id),
  );
  return response.data;
};

// Fetch paginated leaver history (P45 records with taxYear) for a subcontractor.
// Used by P60 download flow to exclude tax years that already have a P45 issued.
export const getLeaverHistoryListApi = async (
  id: string,
  params: { page?: number; size?: number } = { page: 0, size: 1000 },
): Promise<{ data: ILeaverHistory[]; totalDocs: number; success: boolean }> => {
  const response = await axios.get(endPoints.employee.leaverHistory(id), {
    params,
  });
  return response.data;
};

export const reinstatementEmployeeApi = async (
  id: string,
  params: ReinstatementParams,
): Promise<ReinstatementResponse> => {
  const response = await axios.put(
    endPoints.employee.reinstatement(id),
    params,
  );
  return response.data;
};

export const validateIssueP45BySubcontractorIdApi = async (
  subcontractorId: string,
): Promise<ValidateIssueP45BySubcontractorIdResponse> => {
  const response = await axios.get(
    endPoints.report.dormant.validateP45BySubcontractorId(subcontractorId),
  );
  return response.data;
};

export const submitIssueP45BySubcontractorIdApi = async (
  subcontractorId: string,
  params: SubmitIssueP45BySubcontractorIdParams,
): Promise<SubmitIssueP45BySubcontractorIdResponse> => {
  const { retainedPayoutDecision, ...query } = params;
  const response = await axios.post(
    endPoints.report.dormant.p45BySubcontractorId(subcontractorId),
    retainedPayoutDecision,
    { params: query },
  );
  return response.data;
};

export const submitIssueP45BySubcontractorIdIrelandApi = async (
  subcontractorId: string,
  params: SubmitIssueP45BySubcontractorIdParams,
): Promise<SubmitIssueP45BySubcontractorIdResponse> => {
  const response = await axios.post(
    endPoints.report.dormant.p45BySubcontractorIdIreland(subcontractorId), {},
    { params },
  );
  return response.data;
};